module.exports = __webpack_public_path__ + "img/flag-blue.08bb645d.svg";